(function () {
  'use strict';

  angular
    .module('dashboard.project.overview')
    .controller('dashboardProjectOverviewCtrl', dashboardProjectOverviewCtrl);

  dashboardProjectOverviewCtrl.$inject = [
    'DashboardProjectOverview',
    'moment',
    '$translate',
    '$rootScope',
    '$scope',
    'datamatic',
  ];

  function dashboardProjectOverviewCtrl(
    DashboardProjectOverview,
    moment,
    $translate,
    $rootScope,
    $scope,
    datamatic,
  ) {
    var vm = this;

    var textWeekly = $translate.instant('reports.page.byprojects.weekly');
    var textMonthly = $translate.instant('reports.page.byprojects.monthly');
    var textAnnual = $translate.instant('reports.page.byprojects.annual');
    var textAllTime = $translate.instant('reports.page.byprojects.all.time');

    $rootScope.$on('$translateChangeSuccess', function () {
      textWeekly = $translate.instant('reports.page.byprojects.weekly');
      textMonthly = $translate.instant('reports.page.byprojects.monthly');
      textAnnual = $translate.instant('reports.page.byprojects.annual');
      textAllTime = $translate.instant('reports.page.byprojects.all.time');
    });

    vm.getProjectHeader = getProjectHeader;
    vm.reportPeriods = reportPeriods();
    vm.reportPeriod = 'month';
    vm.projects = getProjectOverview();
    vm.noData = false;

    var dmColors = ['', '#2196f3', '#FD9C35', '#BD3B47', '#DD4444'];

    var dmCategories = [
      '',
      $translate.instant('reports.page.dashboard.interests'),
      $translate.instant('reports.page.dashboard.reservations'),
      $translate.instant('reports.page.dashboard.deals'),
      $translate.instant('reports.page.byprojects.deals.value.total.mln'),
    ];

    $scope.updateData = function (periodStart, periodEnd) {
      getProjectOverview(periodStart, periodEnd);
    };

    function getProjectOverview(periodStart, periodEnd) {
      if (!periodStart || !periodEnd) {
        return;
      }

      DashboardProjectOverview.getProjectOverview({
        from: periodStart,
        to: periodEnd,
      }).$promise.then(
        function (response) {
          if (Object.keys(response).length == 2) {
            vm.noData = true;
            return;
          }
          vm.projects = response;
          vm.noData = false;
          mapForDatamaticChart(response);
        },
        function (error) {
          vm.noData = true;
        },
      );
    }

    function isProject(key) {
      return key.match(/P\d+$/) ? true : false;
    }

    function isProjectWithRoom(key) {
      return key.match(/P\d+-R/) ? true : false;
    }

    function entityName(key, value) {
      var entityIds = key.split('-');
      var name = '';

      var isHouse = function (key) {
        return key.indexOf('H') >= 0 ? true : false;
      };

      var isSection = function (key) {
        return key.indexOf('S') >= 0 ? true : false;
      };

      var getRoomNum = function (key) {
        var matchKey = key.match(/\d+/g);

        return matchKey ? matchKey[0] : null;
      };

      if (entityIds.length == 3) {
        name = getRoomNum(entityIds[2]) + '-' + textRoom;
      } else if (entityIds.length == 2 && isHouse(entityIds[1])) {
        name = value.house_name;
      } else if (entityIds.length == 2 && isSection(entityIds[1])) {
        name = value.house_name + '-' + value.section_name;
      } else if (entityIds.length == 2) {
        name = getRoomNum(entityIds[1]) + '-' + textRoom;
      } else if (entityIds.length == 1) {
        name = value.project_name;
      }

      return name;
    }

    function getProjectHeader(project) {
      return Object.values(project)[0].project_name;
    }

    function reportPeriods() {
      return [
        {
          id: 'week',
          name: textWeekly,
        },
        {
          id: 'month',
          name: textMonthly,
        },
        {
          id: 'year',
          name: textAnnual,
        },
        {
          id: 'all',
          name: textAllTime,
        },
      ];
    }

    function mapForDatamaticChart(projects) {
      var dmProjData = [];

      angular.forEach(projects, function (value, key) {
        if (value.total) {
          dmProjData.push([
            value.total.project_name,
            value.total.interested,
            value.total.reservations,
            value.total.deals,
            value.total.deals_value
              ? parseFloat(value.total.deals_value.replace(/,/g, '')) /
                  1000000 +
                ''
              : '0',
          ]);
        }
      });

      // sorting projects by highest sum of all of the values
      var sortedProjects = dmProjData.sort(function (a, b) {
        return b[1] + b[2] + b[3] + b[4] - (a[1] + a[2] + a[3] + a[4]);
      });

      var dmTemplate = [dmCategories, dmColors];

      // determine height of the chart depending on the number of projects
      $scope.height =
        sortedProjects.length < 4
          ? sortedProjects.length * (90 + 100 / sortedProjects.length)
          : sortedProjects.length * (60 + 100 / sortedProjects.length);
      $scope.data = dmTemplate.concat(sortedProjects);
      $rootScope.$broadcast('chart.update');
    }
  }
})();
